import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISegment, ISegmentFilter, ISegmentFilterRequest } from '../models/segment.model';
import { APIResponse } from 'src/app/core/models/api-response';
import { environment } from 'src/environments/environment';
import { IPageCount } from 'src/app/shared/models/page.model';

@Injectable({
  providedIn: 'root'
})
export class SegmentsService {

  constructor(
    private http: HttpClient
  ) { }

  public fetchAllSegments(includes?: Array<string>): Observable<APIResponse<ISegment>> {
    let params = new HttpParams();
    if (includes) {
      params = params.set('includes', includes.join(','));
    }
    return this.http.get<APIResponse<ISegment>>(`${environment.BASE_URL_API}segments`, { params });
  };

  public fetchSegments(page: IPageCount, filter: ISegmentFilterRequest | undefined,
    search: string | undefined

  ): Observable<APIResponse<ISegment>> {
    const params = new HttpParams()
      .set('page', page.number)
      .set('limit', page.size)
      .set('filters', JSON.stringify(filter))
      .set('key', search!);
    return this.http.get<APIResponse<ISegment>>(environment.BASE_URL_API + 'segments', { params });
  }

  public addSegment(segment: Omit<ISegment, 'id'>): Observable<APIResponse<ISegment>> {
    return this.http.post<APIResponse<ISegment>>(`${environment.BASE_URL_API}segments`, segment);
  };

  public updateSegment(id: number, segment: Omit<ISegment, 'id'>): Observable<APIResponse<ISegment>> {
    return this.http.patch<APIResponse<ISegment>>(`${environment.BASE_URL_API}segments/${id}`, segment);
  };
  public deleteSegment(id?: number): Observable<any> {
    return this.http.delete<APIResponse<ISegment>>(
      environment.BASE_URL_API + 'segments/' + id,
    );
  }

}
